/* global attachEvent, VideoPlayer */
// *******************************************************************************
// 1.0 - Embed Video
// *******************************************************************************

attachEvent('.video__poster', 'click', (ev) => {
  const parentElem = ev.target.closest('.video__wrapper');
  VideoPlayer(parentElem);
});
